import { defineStore } from 'pinia'

export const useSessionStore = defineStore({
  id: 'session',
  persist: true,

  state: () => ({
    token: '',
    email: '',
    phone: '',
    hasArtificialIntelligence: false,
  }),

  getters: {
    hasSession: (state) => state.token !== '',
    getSessionTypeBot: (state) => `${state.phone}@beminteligencia.com.br`,
    getEmail: (state) => state.email,
    getPhone: (state) => state.phone,
    getHasArtificialIntelligence: (state) => state.hasArtificialIntelligence,
  },

  actions: {
    createSession(token: string, email: string, hasArtificialIntelligence: boolean, phone?: string) {
      this.token = token
      this.email = email
      this.phone = phone || ''
      this.hasArtificialIntelligence = hasArtificialIntelligence
    },
    destroySession() {
      this.token = ''
      this.email = ''
      this.phone = ''
      this.hasArtificialIntelligence = false
    },
  },
})
